@switch (context ? context.type : '') {
    @default {
        <fui-edit-radio-input [disabled]="disabled || readOnly" [equivalent]="equivalent" [id]="id" #input
                              [label]="label" [name]="name"
                              [(ngModel)]="value" (focussed$)="onFocussed($event)"></fui-edit-radio-input>
    }
    @case (contextType.FILTER) {
        <fui-filter-radio-input [disabled]="disabled || readOnly" [equivalent]="equivalent" [id]="id" #input
                                [label]="label"
                                [name]="name" [(ngModel)]="value" (focussed$)="onFocussed($event)"
        ></fui-filter-radio-input>
    }
    @case (contextType.INLINE) {
        <fui-inline-radio-input [disabled]="disabled || readOnly" [equivalent]="equivalent" [id]="id" #input
                                [label]="label"
                                [name]="name" [(ngModel)]="value" (focussed$)="onFocussed($event)"
        ></fui-inline-radio-input>
    }
    @case (contextType.INLINE_ACTION) {
        <fui-inline-radio-input [disabled]="disabled || readOnly" [equivalent]="equivalent" [id]="id" #input
                                [label]="label"
                                [name]="name" [(ngModel)]="value" class="action" (focussed$)="onFocussed($event)"
        ></fui-inline-radio-input>
    }
    @case (contextType.PILL) {
        <fui-radio-pill></fui-radio-pill>
    }
}
